import React from 'react';
import { FallOffsBoard, Layout } from 'features/command-center';
import usePageTitle from 'hooks/usePageTitle';
import strings from 'strings';
import { PageTitles } from 'UI/constants/defaults';

export const FallOffsBoardPage = () => {
  usePageTitle({ title: PageTitles.CommandCenterFallOffsBoard });

  return (
    <Layout title={strings.commandCenter.fallOffsBoard.title} path={strings.commandCenter.title}>
      <FallOffsBoard />
    </Layout>
  );
};
